import { ordersStatisticsAggregateDate as orderUtilsOrdersStatisticsAggregateDate } from '@utils/orderUtils';
import { currencyConstants } from '@utils/constants';
import currencySimpleUtility from '@utils/currencySimple';
import mutationTypes from '@helpers/storeFactories/helpers/mutationTypes';

const STORE_NAME = 'salesTransactions';

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        items: null,
        totalCount: 0,
    },
    mutations: {
        [mutationTypes.SET_DATA](state, data) {
            state.items = [...data.salesTransactions.items];
            state.totalCount = data.salesTransactions.totalCount;
        },
        [mutationTypes.CLEAR_DATA](state) {
            state.items = null;
            state.totalCount = 0;
        },
    },
    getters: {
        transactions:
            (state, getters, rootState) =>
            (returnType = Array) => {
                if (state.items) {
                    let returnTypeObject = [],
                        returnTypeArray = [];
                    state.items.forEach((item) => {
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            transactions: item.transactions,
                        });
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.transactions,
                        ]);
                    });

                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }
                return null;
            },
        revenue:
            (state, getters, rootState) =>
            (returnType = Array) => {
                if (state.items) {
                    let returnTypeObject = [],
                        returnTypeArray = [];
                    state.items.forEach((item) => {
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            revenue: currencySimpleUtility(item.revenue, currencyConstants.DEFAULT),
                        });
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.revenue,
                        ]);
                    });

                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }
                return null;
            },
    },
};
